import { CheckoutProps } from '@wix/checkout-components';
import { FedopsReporter } from '../../../../types';

export interface UseOnSubmitPendingOptions {
  removeUnloadListener: () => void;
  endSubmitOrderPageInteraction: FedopsReporter;
}

export function useOnSubmitPending(
  options?: UseOnSubmitPendingOptions,
): CheckoutProps['onSubmitPending'] | undefined {
  if (options) {
    return () => {
      const { removeUnloadListener } = options;
      removeUnloadListener && removeUnloadListener();
      options.endSubmitOrderPageInteraction();
      return {
        preventRedirect: false,
      };
    };
  }

  return undefined;
}
